import React from "react"
import PropTypes from "prop-types"
import { Navigate, matchPath, useLocation } from "react-router-dom"
import { ROUTES } from "constants/routes"
import { isAuthenticated } from "utils/authUtils"
import { resolvePostLoginRedirect } from "utils/accessibleRoutes"

/** Public routes that remain reachable while authenticated. */
const AUTHENTICATED_PUBLIC_PATTERNS = [
  ROUTES.LOGOUT,
  ROUTES.FORBIDDEN,
  ROUTES.NOT_FOUND,
  ROUTES.SERVER_ERROR,
  ROUTES.SESSION_EXPIRED,
  "/system-maintenance",
  ROUTES.VERIFY_PASSWORD,
  ROUTES.RESET_PASSWORD,
  ROUTES.PUBLIC_PRIVACY_POLICY,
  ROUTES.PUBLIC_TERMS_CONDITIONS,
  ROUTES.PUBLIC_RIDER_PRIVACY_POLICY,
  ROUTES.PUBLIC_RIDER_TERMS_CONDITIONS,
  ROUTES.DELETE_ACCOUNT,
  ROUTES.PUBLIC_RATING,
]

const isAuthenticatedPublicPath = pathname =>
  AUTHENTICATED_PUBLIC_PATTERNS.some(pattern =>
    matchPath({ path: pattern, end: true }, pathname)
  )

/**
 * Redirects authenticated users away from guest-only public pages
 * (landing, login, register, forgot password, etc.).
 */
const GuestRoute = ({ children }) => {
  const location = useLocation()

  if (isAuthenticatedPublicPath(location.pathname)) {
    return children
  }

  if (isAuthenticated()) {
    const target = resolvePostLoginRedirect(location.search)
    return <Navigate to={target} replace />
  }

  return children
}

GuestRoute.propTypes = {
  children: PropTypes.node,
}

export default GuestRoute
